import PaymentMethod from "../../../entities/PaymentMethod";

class AddAgencyBalanceRequest {

    public amount: number;
    public paymentMethod?: PaymentMethod;
    public comment?: string;

    constructor(amount: number, paymentMethod?: PaymentMethod, comment?: string) {
        this.comment = comment;
        this.paymentMethod = paymentMethod;
        this.amount = amount;
    }

}

export default AddAgencyBalanceRequest;